const SurveySection = ({ name, children }) => {
  return (
    <div className="md:border md:border-gray-300 rounded-md md:px-3 pt-3 pb-5 shadow-sm mt-7">
      <h1 className="mb-5 md:mb-3 font-semibold text-green-600 -mt-6 md:-mt-7 bg-gray-100 md:bg-white w-full md:w-fit px-2 py-1 md:py-0 md:text-lg">
        {name}
      </h1>
      {children}
    </div>
  );
};

export default SurveySection;
